module.exports = __webpack_public_path__ + "img/VanBreda_logo.e82e720b.png";